export interface ISelectOption {
  text: string;
  value: string;
  available?: boolean;
}
